import type { Video } from "@/mocks/videos";
import VideoCard from "@/components/base/VideoCard";
import SectionHeader from "@/components/base/SectionHeader";

interface VideoGridSectionProps {
  eyebrow: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
  videos: Video[];
  showRank?: boolean;
  showSummary?: boolean;
}

export default function VideoGridSection({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel,
  videos,
  showRank = false,
  showSummary = false,
}: VideoGridSectionProps) {
  return (
    <section className="px-4 md:px-8 lg:px-12">
      <SectionHeader
        eyebrow={eyebrow}
        title={title}
        description={description}
        moreTo={moreTo}
        moreLabel={moreLabel}
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
        {videos.map((video, index) => (
          <VideoCard
            key={video.id}
            video={video}
            showSummary={showSummary}
            rank={showRank ? index + 1 : undefined}
          />
        ))}
      </div>
    </section>
  );
}